// OrganisationPage.js
import React, { useState, useEffect } from 'react';
import { useDataQuery } from '@dhis2/app-runtime';
import { CircularLoader } from '@dhis2/ui';
import OrgUnitForm from './components/SuperUserOrgUnitForm';
import { useNavigate } from 'react-router-dom';

const CURRENT_USER_QUERY = {
  me: {
    resource: 'me',
    params: {
      fields: 'organisationUnits[id,name]'
    }
  }
};

const OrganisationPage = () => {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const { data: currentUserData, loading, error } = useDataQuery(CURRENT_USER_QUERY);

  useEffect(() => {
    if (!loading && currentUserData?.me?.organisationUnits?.length > 0) {
      navigate('/dashboard');
    }
  }, [currentUserData, loading, navigate]);

  if (loading) {
    return <CircularLoader />;
  }

  if (error) {
    return <div>Error loading user data</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h3 style={{ color: '#4CAF50' }}>First things first,</h3>
      <h4 style={{ marginBottom: '20px' }}>Create your Organisation to get Started</h4>
      
      {!showForm ? (
        <button 
          onClick={() => setShowForm(true)}
          style={{
            padding: '10px 20px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Create your Organization
        </button>
      ) : (
        <OrgUnitForm 
          onCancel={() => setShowForm(false)} 
          onSuccess={() => navigate('/dashboard')}
        />
      )}
    </div>
  );
};

export default OrganisationPage;